import React from 'react';
import md5 from 'md5';

interface GravatarProps {
  email: string;
  size?: number;
  photoURL?: string | null; // User's profile photo URL (from Google or custom upload)
  className?: string; // Optional custom class name
}

const Gravatar: React.FC<GravatarProps> = ({ email, size = 50, photoURL, className }) => {
  // Extract username from email and format for alt text
  const username = email.split('@')[0];
  const capitalizedUsername = username.charAt(0).toUpperCase() + username.slice(1);
  const altText = `${capitalizedUsername}'s Avatar`;

  // Use photoURL if available (Google profile or custom upload), otherwise fall back to Gravatar
  let avatarURL: string;
  if (photoURL) {
    avatarURL = photoURL;
  } else {
    const emailHash = md5(email.toLowerCase());
    avatarURL = `https://www.gravatar.com/avatar/${emailHash}?s=${size}&d=retro`;
  }

  return (
    <img
      src={avatarURL}
      alt={altText}
      className={className || 'comment-list__avatar'}
      style={{ objectFit: 'cover' }}
      onError={(e) => {
        // Fallback to Gravatar if photoURL fails to load
        if (photoURL) {
          const emailHash = md5(email.toLowerCase());
          (e.target as HTMLImageElement).src = `https://www.gravatar.com/avatar/${emailHash}?s=${size}&d=retro`;
        }
      }}
    />
  );
};

export default Gravatar;